const FlyerHeadTitle = ({
    logoData,
    flyerSettings,
    formartedCurrentPeriodeStartDate,
    formartedCurrentPeriodeEndDate
}) => {
    const { titleTopText, logo } = flyerSettings
    const { flyer_url, flyer_logo_subtitle } = logoData
    const logoUrl = logo && logo.url ? logo.url : flyer_url

    return (
        <div>
            {logoUrl && <div className="logo-container"><div className="logo" style={{backgroundImage: `url("${logoUrl}")`}}></div></div>}

            {flyer_logo_subtitle && <div className="flyer-logo-subtitle-container">{flyer_logo_subtitle}</div>}

            {titleTopText || titleTopText === '' ? (
                <div className="week-container" dangerouslySetInnerHTML={{ __html: titleTopText}}></div>
            ) : formartedCurrentPeriodeStartDate && formartedCurrentPeriodeEndDate ? (
                <div className="week-container">von {formartedCurrentPeriodeStartDate} bis {formartedCurrentPeriodeEndDate}</div>
            ) : ''}
        </div>
    )
}

export default FlyerHeadTitle